(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zyna-01-barra"] && !Shopify.designMode) return;
  try {
    
(function(){
if(window.zynaLoaded)return;window.zynaLoaded=true;
window.zynaInit=function(){
var roots=document.querySelectorAll('.zh:not(.zh-js)');
[].forEach.call(roots,function(r){
 if(!('IntersectionObserver' in window))return;
 r.classList.add('zh-js');
 var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('zh-on');io.unobserve(e.target);}});},{threshold:.15});
 [].forEach.call(r.querySelectorAll('.zh-rv'),function(el){io.observe(el);});
});
[].forEach.call(document.querySelectorAll('.zh-tabs:not([data-ok])'),function(t){
 t.setAttribute('data-ok','1');var root=t.parentNode;
 [].forEach.call(t.querySelectorAll('.zh-tab'),function(b){
  b.addEventListener('click',function(){
   [].forEach.call(t.querySelectorAll('.zh-tab'),function(x){x.setAttribute('aria-selected',x===b?'true':'false');});
   [].forEach.call(root.querySelectorAll('.zh-panel'),function(p){p.hidden=(p.id!==b.getAttribute('aria-controls'));});
  });
 });
});
[].forEach.call(document.querySelectorAll('.zh-addform:not([data-ok])'),function(f){
 f.setAttribute('data-ok','1');
 f.addEventListener('submit',function(e){
  if(!window.fetch)return;
  e.preventDefault();
  var b=f.querySelector('button'),txt=b.textContent,root=f.closest('.zh'),toast=root&&root.querySelector('.zh-toast');
  b.disabled=true;b.textContent='Agregando…';
  var base=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
  fetch(base+'cart/add.js',{method:'POST',headers:{'Accept':'application/json'},body:new FormData(f)})
  .then(function(r){return r.json().then(function(j){return {ok:r.ok,j:j};});})
  .then(function(res){
   if(!res.ok)throw new Error(res.j.description||res.j.message||'No se pudo agregar');
   b.textContent='✓ Agregado';
   if(toast){toast.querySelector('.zh-toast-msg').textContent=res.j.product_title+' se agregó a tu carrito';}
   return fetch(base+'cart.js').then(function(r){return r.json();}).then(function(cart){
    document.dispatchEvent(new CustomEvent('cart:update',{bubbles:true,detail:{resource:cart,sourceId:'zyna',data:{itemCount:cart.item_count,source:'zyna'}}}));
    [].forEach.call(document.querySelectorAll('[data-cart-count],.cart-count-bubble span,.cart-count'),function(c){c.textContent=cart.item_count;});
   });
  })
  .catch(function(err){if(toast){toast.querySelector('.zh-toast-msg').textContent=err.message;}else{f.submit();}})
  .then(function(){
   if(toast){toast.classList.add('zh-show');clearTimeout(toast._t);toast._t=setTimeout(function(){toast.classList.remove('zh-show');},6000);}
   setTimeout(function(){b.disabled=false;b.textContent=txt;},1800);
  });
 });
});
[].forEach.call(document.querySelectorAll('.zh-fan:not([data-ok])'),function(fan){
 fan.setAttribute('data-ok','1');
 var cards=[].slice.call(fan.querySelectorAll('.zh-card[data-i]'));if(cards.length<3)return;
 var busy=false,timer;
 function pos(c){return c.classList.contains('zh-pos-l')?'l':c.classList.contains('zh-pos-r')?'r':'c';}
 function front(c){
  if(busy||pos(c)==='c')return;busy=true;
  var cur=cards.filter(function(x){return pos(x)==='c';})[0],p=pos(c);
  c.classList.remove('zh-pos-'+p);c.classList.add('zh-pos-c');
  cur.classList.remove('zh-pos-c');cur.classList.add('zh-pos-'+p);
  setTimeout(function(){busy=false;},700);
 }
 cards.forEach(function(c){
  c.addEventListener('mouseenter',function(){clearTimeout(timer);timer=setTimeout(function(){front(c);},120);});
  c.addEventListener('mouseleave',function(){clearTimeout(timer);});
  c.addEventListener('click',function(){front(c);});
 });
});
[].forEach.call(document.querySelectorAll('.zh-snd:not([data-ok])'),function(b){
 b.setAttribute('data-ok','1');
 b.addEventListener('click',function(){var v=b.parentNode.querySelector('video');if(!v)return;
  v.muted=!v.muted;if(!v.muted){v.currentTime=0;v.play();}
  b.classList.toggle('zh-sonando',!v.muted);b.setAttribute('aria-label',v.muted?'Activar sonido':'Silenciar');});
});
};
zynaInit();
document.addEventListener("shopify:section:load",function(){setTimeout(zynaInit,50);});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zyna-02-portada"] && !Shopify.designMode) return;
  try {
    
(function(){
if(window.zynaLoaded)return;window.zynaLoaded=true;
window.zynaInit=function(){
var roots=document.querySelectorAll('.zh:not(.zh-js)');
[].forEach.call(roots,function(r){
 if(!('IntersectionObserver' in window))return;
 r.classList.add('zh-js');
 var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('zh-on');io.unobserve(e.target);}});},{threshold:.15});
 [].forEach.call(r.querySelectorAll('.zh-rv'),function(el){io.observe(el);});
});
[].forEach.call(document.querySelectorAll('.zh-tabs:not([data-ok])'),function(t){
 t.setAttribute('data-ok','1');var root=t.parentNode;
 [].forEach.call(t.querySelectorAll('.zh-tab'),function(b){
  b.addEventListener('click',function(){
   [].forEach.call(t.querySelectorAll('.zh-tab'),function(x){x.setAttribute('aria-selected',x===b?'true':'false');});
   [].forEach.call(root.querySelectorAll('.zh-panel'),function(p){p.hidden=(p.id!==b.getAttribute('aria-controls'));});
  });
 });
});
[].forEach.call(document.querySelectorAll('.zh-addform:not([data-ok])'),function(f){
 f.setAttribute('data-ok','1');
 f.addEventListener('submit',function(e){
  if(!window.fetch)return;
  e.preventDefault();
  var b=f.querySelector('button'),txt=b.textContent,root=f.closest('.zh'),toast=root&&root.querySelector('.zh-toast');
  b.disabled=true;b.textContent='Agregando…';
  var base=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
  fetch(base+'cart/add.js',{method:'POST',headers:{'Accept':'application/json'},body:new FormData(f)})
  .then(function(r){return r.json().then(function(j){return {ok:r.ok,j:j};});})
  .then(function(res){
   if(!res.ok)throw new Error(res.j.description||res.j.message||'No se pudo agregar');
   b.textContent='✓ Agregado';
   if(toast){toast.querySelector('.zh-toast-msg').textContent=res.j.product_title+' se agregó a tu carrito';}
   return fetch(base+'cart.js').then(function(r){return r.json();}).then(function(cart){
    document.dispatchEvent(new CustomEvent('cart:update',{bubbles:true,detail:{resource:cart,sourceId:'zyna',data:{itemCount:cart.item_count,source:'zyna'}}}));
    [].forEach.call(document.querySelectorAll('[data-cart-count],.cart-count-bubble span,.cart-count'),function(c){c.textContent=cart.item_count;});
   });
  })
  .catch(function(err){if(toast){toast.querySelector('.zh-toast-msg').textContent=err.message;}else{f.submit();}})
  .then(function(){
   if(toast){toast.classList.add('zh-show');clearTimeout(toast._t);toast._t=setTimeout(function(){toast.classList.remove('zh-show');},6000);}
   setTimeout(function(){b.disabled=false;b.textContent=txt;},1800);
  });
 });
});
[].forEach.call(document.querySelectorAll('.zh-fan:not([data-ok])'),function(fan){
 fan.setAttribute('data-ok','1');
 var cards=[].slice.call(fan.querySelectorAll('.zh-card[data-i]'));if(cards.length<3)return;
 var busy=false,timer;
 function pos(c){return c.classList.contains('zh-pos-l')?'l':c.classList.contains('zh-pos-r')?'r':'c';}
 function front(c){
  if(busy||pos(c)==='c')return;busy=true;
  var cur=cards.filter(function(x){return pos(x)==='c';})[0],p=pos(c);
  c.classList.remove('zh-pos-'+p);c.classList.add('zh-pos-c');
  cur.classList.remove('zh-pos-c');cur.classList.add('zh-pos-'+p);
  setTimeout(function(){busy=false;},700);
 }
 cards.forEach(function(c){
  c.addEventListener('mouseenter',function(){clearTimeout(timer);timer=setTimeout(function(){front(c);},120);});
  c.addEventListener('mouseleave',function(){clearTimeout(timer);});
  c.addEventListener('click',function(){front(c);});
 });
});
[].forEach.call(document.querySelectorAll('.zh-snd:not([data-ok])'),function(b){
 b.setAttribute('data-ok','1');
 b.addEventListener('click',function(){var v=b.parentNode.querySelector('video');if(!v)return;
  v.muted=!v.muted;if(!v.muted){v.currentTime=0;v.play();}
  b.classList.toggle('zh-sonando',!v.muted);b.setAttribute('aria-label',v.muted?'Activar sonido':'Silenciar');});
});
};
zynaInit();
document.addEventListener("shopify:section:load",function(){setTimeout(zynaInit,50);});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zyna-03-confianza"] && !Shopify.designMode) return;
  try {
    
(function(){
if(window.zynaLoaded)return;window.zynaLoaded=true;
window.zynaInit=function(){
var roots=document.querySelectorAll('.zh:not(.zh-js)');
[].forEach.call(roots,function(r){
 if(!('IntersectionObserver' in window))return;
 r.classList.add('zh-js');
 var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('zh-on');io.unobserve(e.target);}});},{threshold:.15});
 [].forEach.call(r.querySelectorAll('.zh-rv'),function(el){io.observe(el);});
});
[].forEach.call(document.querySelectorAll('.zh-tabs:not([data-ok])'),function(t){
 t.setAttribute('data-ok','1');var root=t.parentNode;
 [].forEach.call(t.querySelectorAll('.zh-tab'),function(b){
  b.addEventListener('click',function(){
   [].forEach.call(t.querySelectorAll('.zh-tab'),function(x){x.setAttribute('aria-selected',x===b?'true':'false');});
   [].forEach.call(root.querySelectorAll('.zh-panel'),function(p){p.hidden=(p.id!==b.getAttribute('aria-controls'));});
  });
 });
});
[].forEach.call(document.querySelectorAll('.zh-addform:not([data-ok])'),function(f){
 f.setAttribute('data-ok','1');
 f.addEventListener('submit',function(e){
  if(!window.fetch)return;
  e.preventDefault();
  var b=f.querySelector('button'),txt=b.textContent,root=f.closest('.zh'),toast=root&&root.querySelector('.zh-toast');
  b.disabled=true;b.textContent='Agregando…';
  var base=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
  fetch(base+'cart/add.js',{method:'POST',headers:{'Accept':'application/json'},body:new FormData(f)})
  .then(function(r){return r.json().then(function(j){return {ok:r.ok,j:j};});})
  .then(function(res){
   if(!res.ok)throw new Error(res.j.description||res.j.message||'No se pudo agregar');
   b.textContent='✓ Agregado';
   if(toast){toast.querySelector('.zh-toast-msg').textContent=res.j.product_title+' se agregó a tu carrito';}
   return fetch(base+'cart.js').then(function(r){return r.json();}).then(function(cart){
    document.dispatchEvent(new CustomEvent('cart:update',{bubbles:true,detail:{resource:cart,sourceId:'zyna',data:{itemCount:cart.item_count,source:'zyna'}}}));
    [].forEach.call(document.querySelectorAll('[data-cart-count],.cart-count-bubble span,.cart-count'),function(c){c.textContent=cart.item_count;});
   });
  })
  .catch(function(err){if(toast){toast.querySelector('.zh-toast-msg').textContent=err.message;}else{f.submit();}})
  .then(function(){
   if(toast){toast.classList.add('zh-show');clearTimeout(toast._t);toast._t=setTimeout(function(){toast.classList.remove('zh-show');},6000);}
   setTimeout(function(){b.disabled=false;b.textContent=txt;},1800);
  });
 });
});
[].forEach.call(document.querySelectorAll('.zh-fan:not([data-ok])'),function(fan){
 fan.setAttribute('data-ok','1');
 var cards=[].slice.call(fan.querySelectorAll('.zh-card[data-i]'));if(cards.length<3)return;
 var busy=false,timer;
 function pos(c){return c.classList.contains('zh-pos-l')?'l':c.classList.contains('zh-pos-r')?'r':'c';}
 function front(c){
  if(busy||pos(c)==='c')return;busy=true;
  var cur=cards.filter(function(x){return pos(x)==='c';})[0],p=pos(c);
  c.classList.remove('zh-pos-'+p);c.classList.add('zh-pos-c');
  cur.classList.remove('zh-pos-c');cur.classList.add('zh-pos-'+p);
  setTimeout(function(){busy=false;},700);
 }
 cards.forEach(function(c){
  c.addEventListener('mouseenter',function(){clearTimeout(timer);timer=setTimeout(function(){front(c);},120);});
  c.addEventListener('mouseleave',function(){clearTimeout(timer);});
  c.addEventListener('click',function(){front(c);});
 });
});
[].forEach.call(document.querySelectorAll('.zh-snd:not([data-ok])'),function(b){
 b.setAttribute('data-ok','1');
 b.addEventListener('click',function(){var v=b.parentNode.querySelector('video');if(!v)return;
  v.muted=!v.muted;if(!v.muted){v.currentTime=0;v.play();}
  b.classList.toggle('zh-sonando',!v.muted);b.setAttribute('aria-label',v.muted?'Activar sonido':'Silenciar');});
});
};
zynaInit();
document.addEventListener("shopify:section:load",function(){setTimeout(zynaInit,50);});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zyna-04-video"] && !Shopify.designMode) return;
  try {
    
(function(){
if(window.zynaLoaded)return;window.zynaLoaded=true;
window.zynaInit=function(){
var roots=document.querySelectorAll('.zh:not(.zh-js)');
[].forEach.call(roots,function(r){
 if(!('IntersectionObserver' in window))return;
 r.classList.add('zh-js');
 var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('zh-on');io.unobserve(e.target);}});},{threshold:.15});
 [].forEach.call(r.querySelectorAll('.zh-rv'),function(el){io.observe(el);});
});
[].forEach.call(document.querySelectorAll('.zh-tabs:not([data-ok])'),function(t){
 t.setAttribute('data-ok','1');var root=t.parentNode;
 [].forEach.call(t.querySelectorAll('.zh-tab'),function(b){
  b.addEventListener('click',function(){
   [].forEach.call(t.querySelectorAll('.zh-tab'),function(x){x.setAttribute('aria-selected',x===b?'true':'false');});
   [].forEach.call(root.querySelectorAll('.zh-panel'),function(p){p.hidden=(p.id!==b.getAttribute('aria-controls'));});
  });
 });
});
[].forEach.call(document.querySelectorAll('.zh-addform:not([data-ok])'),function(f){
 f.setAttribute('data-ok','1');
 f.addEventListener('submit',function(e){
  if(!window.fetch)return;
  e.preventDefault();
  var b=f.querySelector('button'),txt=b.textContent,root=f.closest('.zh'),toast=root&&root.querySelector('.zh-toast');
  b.disabled=true;b.textContent='Agregando…';
  var base=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
  fetch(base+'cart/add.js',{method:'POST',headers:{'Accept':'application/json'},body:new FormData(f)})
  .then(function(r){return r.json().then(function(j){return {ok:r.ok,j:j};});})
  .then(function(res){
   if(!res.ok)throw new Error(res.j.description||res.j.message||'No se pudo agregar');
   b.textContent='✓ Agregado';
   if(toast){toast.querySelector('.zh-toast-msg').textContent=res.j.product_title+' se agregó a tu carrito';}
   return fetch(base+'cart.js').then(function(r){return r.json();}).then(function(cart){
    document.dispatchEvent(new CustomEvent('cart:update',{bubbles:true,detail:{resource:cart,sourceId:'zyna',data:{itemCount:cart.item_count,source:'zyna'}}}));
    [].forEach.call(document.querySelectorAll('[data-cart-count],.cart-count-bubble span,.cart-count'),function(c){c.textContent=cart.item_count;});
   });
  })
  .catch(function(err){if(toast){toast.querySelector('.zh-toast-msg').textContent=err.message;}else{f.submit();}})
  .then(function(){
   if(toast){toast.classList.add('zh-show');clearTimeout(toast._t);toast._t=setTimeout(function(){toast.classList.remove('zh-show');},6000);}
   setTimeout(function(){b.disabled=false;b.textContent=txt;},1800);
  });
 });
});
[].forEach.call(document.querySelectorAll('.zh-fan:not([data-ok])'),function(fan){
 fan.setAttribute('data-ok','1');
 var cards=[].slice.call(fan.querySelectorAll('.zh-card[data-i]'));if(cards.length<3)return;
 var busy=false,timer;
 function pos(c){return c.classList.contains('zh-pos-l')?'l':c.classList.contains('zh-pos-r')?'r':'c';}
 function front(c){
  if(busy||pos(c)==='c')return;busy=true;
  var cur=cards.filter(function(x){return pos(x)==='c';})[0],p=pos(c);
  c.classList.remove('zh-pos-'+p);c.classList.add('zh-pos-c');
  cur.classList.remove('zh-pos-c');cur.classList.add('zh-pos-'+p);
  setTimeout(function(){busy=false;},700);
 }
 cards.forEach(function(c){
  c.addEventListener('mouseenter',function(){clearTimeout(timer);timer=setTimeout(function(){front(c);},120);});
  c.addEventListener('mouseleave',function(){clearTimeout(timer);});
  c.addEventListener('click',function(){front(c);});
 });
});
[].forEach.call(document.querySelectorAll('.zh-snd:not([data-ok])'),function(b){
 b.setAttribute('data-ok','1');
 b.addEventListener('click',function(){var v=b.parentNode.querySelector('video');if(!v)return;
  v.muted=!v.muted;if(!v.muted){v.currentTime=0;v.play();}
  b.classList.toggle('zh-sonando',!v.muted);b.setAttribute('aria-label',v.muted?'Activar sonido':'Silenciar');});
});
};
zynaInit();
document.addEventListener("shopify:section:load",function(){setTimeout(zynaInit,50);});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zyna-05-porque"] && !Shopify.designMode) return;
  try {
    
(function(){
if(window.zynaLoaded)return;window.zynaLoaded=true;
window.zynaInit=function(){
var roots=document.querySelectorAll('.zh:not(.zh-js)');
[].forEach.call(roots,function(r){
 if(!('IntersectionObserver' in window))return;
 r.classList.add('zh-js');
 var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('zh-on');io.unobserve(e.target);}});},{threshold:.15});
 [].forEach.call(r.querySelectorAll('.zh-rv'),function(el){io.observe(el);});
});
[].forEach.call(document.querySelectorAll('.zh-tabs:not([data-ok])'),function(t){
 t.setAttribute('data-ok','1');var root=t.parentNode;
 [].forEach.call(t.querySelectorAll('.zh-tab'),function(b){
  b.addEventListener('click',function(){
   [].forEach.call(t.querySelectorAll('.zh-tab'),function(x){x.setAttribute('aria-selected',x===b?'true':'false');});
   [].forEach.call(root.querySelectorAll('.zh-panel'),function(p){p.hidden=(p.id!==b.getAttribute('aria-controls'));});
  });
 });
});
[].forEach.call(document.querySelectorAll('.zh-addform:not([data-ok])'),function(f){
 f.setAttribute('data-ok','1');
 f.addEventListener('submit',function(e){
  if(!window.fetch)return;
  e.preventDefault();
  var b=f.querySelector('button'),txt=b.textContent,root=f.closest('.zh'),toast=root&&root.querySelector('.zh-toast');
  b.disabled=true;b.textContent='Agregando…';
  var base=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
  fetch(base+'cart/add.js',{method:'POST',headers:{'Accept':'application/json'},body:new FormData(f)})
  .then(function(r){return r.json().then(function(j){return {ok:r.ok,j:j};});})
  .then(function(res){
   if(!res.ok)throw new Error(res.j.description||res.j.message||'No se pudo agregar');
   b.textContent='✓ Agregado';
   if(toast){toast.querySelector('.zh-toast-msg').textContent=res.j.product_title+' se agregó a tu carrito';}
   return fetch(base+'cart.js').then(function(r){return r.json();}).then(function(cart){
    document.dispatchEvent(new CustomEvent('cart:update',{bubbles:true,detail:{resource:cart,sourceId:'zyna',data:{itemCount:cart.item_count,source:'zyna'}}}));
    [].forEach.call(document.querySelectorAll('[data-cart-count],.cart-count-bubble span,.cart-count'),function(c){c.textContent=cart.item_count;});
   });
  })
  .catch(function(err){if(toast){toast.querySelector('.zh-toast-msg').textContent=err.message;}else{f.submit();}})
  .then(function(){
   if(toast){toast.classList.add('zh-show');clearTimeout(toast._t);toast._t=setTimeout(function(){toast.classList.remove('zh-show');},6000);}
   setTimeout(function(){b.disabled=false;b.textContent=txt;},1800);
  });
 });
});
[].forEach.call(document.querySelectorAll('.zh-fan:not([data-ok])'),function(fan){
 fan.setAttribute('data-ok','1');
 var cards=[].slice.call(fan.querySelectorAll('.zh-card[data-i]'));if(cards.length<3)return;
 var busy=false,timer;
 function pos(c){return c.classList.contains('zh-pos-l')?'l':c.classList.contains('zh-pos-r')?'r':'c';}
 function front(c){
  if(busy||pos(c)==='c')return;busy=true;
  var cur=cards.filter(function(x){return pos(x)==='c';})[0],p=pos(c);
  c.classList.remove('zh-pos-'+p);c.classList.add('zh-pos-c');
  cur.classList.remove('zh-pos-c');cur.classList.add('zh-pos-'+p);
  setTimeout(function(){busy=false;},700);
 }
 cards.forEach(function(c){
  c.addEventListener('mouseenter',function(){clearTimeout(timer);timer=setTimeout(function(){front(c);},120);});
  c.addEventListener('mouseleave',function(){clearTimeout(timer);});
  c.addEventListener('click',function(){front(c);});
 });
});
[].forEach.call(document.querySelectorAll('.zh-snd:not([data-ok])'),function(b){
 b.setAttribute('data-ok','1');
 b.addEventListener('click',function(){var v=b.parentNode.querySelector('video');if(!v)return;
  v.muted=!v.muted;if(!v.muted){v.currentTime=0;v.play();}
  b.classList.toggle('zh-sonando',!v.muted);b.setAttribute('aria-label',v.muted?'Activar sonido':'Silenciar');});
});
};
zynaInit();
document.addEventListener("shopify:section:load",function(){setTimeout(zynaInit,50);});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zyna-06-colecciones"] && !Shopify.designMode) return;
  try {
    
(function(){
if(window.zynaLoaded)return;window.zynaLoaded=true;
window.zynaInit=function(){
var roots=document.querySelectorAll('.zh:not(.zh-js)');
[].forEach.call(roots,function(r){
 if(!('IntersectionObserver' in window))return;
 r.classList.add('zh-js');
 var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('zh-on');io.unobserve(e.target);}});},{threshold:.15});
 [].forEach.call(r.querySelectorAll('.zh-rv'),function(el){io.observe(el);});
});
[].forEach.call(document.querySelectorAll('.zh-tabs:not([data-ok])'),function(t){
 t.setAttribute('data-ok','1');var root=t.parentNode;
 [].forEach.call(t.querySelectorAll('.zh-tab'),function(b){
  b.addEventListener('click',function(){
   [].forEach.call(t.querySelectorAll('.zh-tab'),function(x){x.setAttribute('aria-selected',x===b?'true':'false');});
   [].forEach.call(root.querySelectorAll('.zh-panel'),function(p){p.hidden=(p.id!==b.getAttribute('aria-controls'));});
  });
 });
});
[].forEach.call(document.querySelectorAll('.zh-addform:not([data-ok])'),function(f){
 f.setAttribute('data-ok','1');
 f.addEventListener('submit',function(e){
  if(!window.fetch)return;
  e.preventDefault();
  var b=f.querySelector('button'),txt=b.textContent,root=f.closest('.zh'),toast=root&&root.querySelector('.zh-toast');
  b.disabled=true;b.textContent='Agregando…';
  var base=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
  fetch(base+'cart/add.js',{method:'POST',headers:{'Accept':'application/json'},body:new FormData(f)})
  .then(function(r){return r.json().then(function(j){return {ok:r.ok,j:j};});})
  .then(function(res){
   if(!res.ok)throw new Error(res.j.description||res.j.message||'No se pudo agregar');
   b.textContent='✓ Agregado';
   if(toast){toast.querySelector('.zh-toast-msg').textContent=res.j.product_title+' se agregó a tu carrito';}
   return fetch(base+'cart.js').then(function(r){return r.json();}).then(function(cart){
    document.dispatchEvent(new CustomEvent('cart:update',{bubbles:true,detail:{resource:cart,sourceId:'zyna',data:{itemCount:cart.item_count,source:'zyna'}}}));
    [].forEach.call(document.querySelectorAll('[data-cart-count],.cart-count-bubble span,.cart-count'),function(c){c.textContent=cart.item_count;});
   });
  })
  .catch(function(err){if(toast){toast.querySelector('.zh-toast-msg').textContent=err.message;}else{f.submit();}})
  .then(function(){
   if(toast){toast.classList.add('zh-show');clearTimeout(toast._t);toast._t=setTimeout(function(){toast.classList.remove('zh-show');},6000);}
   setTimeout(function(){b.disabled=false;b.textContent=txt;},1800);
  });
 });
});
[].forEach.call(document.querySelectorAll('.zh-fan:not([data-ok])'),function(fan){
 fan.setAttribute('data-ok','1');
 var cards=[].slice.call(fan.querySelectorAll('.zh-card[data-i]'));if(cards.length<3)return;
 var busy=false,timer;
 function pos(c){return c.classList.contains('zh-pos-l')?'l':c.classList.contains('zh-pos-r')?'r':'c';}
 function front(c){
  if(busy||pos(c)==='c')return;busy=true;
  var cur=cards.filter(function(x){return pos(x)==='c';})[0],p=pos(c);
  c.classList.remove('zh-pos-'+p);c.classList.add('zh-pos-c');
  cur.classList.remove('zh-pos-c');cur.classList.add('zh-pos-'+p);
  setTimeout(function(){busy=false;},700);
 }
 cards.forEach(function(c){
  c.addEventListener('mouseenter',function(){clearTimeout(timer);timer=setTimeout(function(){front(c);},120);});
  c.addEventListener('mouseleave',function(){clearTimeout(timer);});
  c.addEventListener('click',function(){front(c);});
 });
});
[].forEach.call(document.querySelectorAll('.zh-snd:not([data-ok])'),function(b){
 b.setAttribute('data-ok','1');
 b.addEventListener('click',function(){var v=b.parentNode.querySelector('video');if(!v)return;
  v.muted=!v.muted;if(!v.muted){v.currentTime=0;v.play();}
  b.classList.toggle('zh-sonando',!v.muted);b.setAttribute('aria-label',v.muted?'Activar sonido':'Silenciar');});
});
};
zynaInit();
document.addEventListener("shopify:section:load",function(){setTimeout(zynaInit,50);});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zyna-07-productos"] && !Shopify.designMode) return;
  try {
    
(function(){
if(window.zynaLoaded)return;window.zynaLoaded=true;
window.zynaInit=function(){
var roots=document.querySelectorAll('.zh:not(.zh-js)');
[].forEach.call(roots,function(r){
 if(!('IntersectionObserver' in window))return;
 r.classList.add('zh-js');
 var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('zh-on');io.unobserve(e.target);}});},{threshold:.15});
 [].forEach.call(r.querySelectorAll('.zh-rv'),function(el){io.observe(el);});
});
[].forEach.call(document.querySelectorAll('.zh-tabs:not([data-ok])'),function(t){
 t.setAttribute('data-ok','1');var root=t.parentNode;
 [].forEach.call(t.querySelectorAll('.zh-tab'),function(b){
  b.addEventListener('click',function(){
   [].forEach.call(t.querySelectorAll('.zh-tab'),function(x){x.setAttribute('aria-selected',x===b?'true':'false');});
   [].forEach.call(root.querySelectorAll('.zh-panel'),function(p){p.hidden=(p.id!==b.getAttribute('aria-controls'));});
  });
 });
});
[].forEach.call(document.querySelectorAll('.zh-addform:not([data-ok])'),function(f){
 f.setAttribute('data-ok','1');
 f.addEventListener('submit',function(e){
  if(!window.fetch)return;
  e.preventDefault();
  var b=f.querySelector('button'),txt=b.textContent,root=f.closest('.zh'),toast=root&&root.querySelector('.zh-toast');
  b.disabled=true;b.textContent='Agregando…';
  var base=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
  fetch(base+'cart/add.js',{method:'POST',headers:{'Accept':'application/json'},body:new FormData(f)})
  .then(function(r){return r.json().then(function(j){return {ok:r.ok,j:j};});})
  .then(function(res){
   if(!res.ok)throw new Error(res.j.description||res.j.message||'No se pudo agregar');
   b.textContent='✓ Agregado';
   if(toast){toast.querySelector('.zh-toast-msg').textContent=res.j.product_title+' se agregó a tu carrito';}
   return fetch(base+'cart.js').then(function(r){return r.json();}).then(function(cart){
    document.dispatchEvent(new CustomEvent('cart:update',{bubbles:true,detail:{resource:cart,sourceId:'zyna',data:{itemCount:cart.item_count,source:'zyna'}}}));
    [].forEach.call(document.querySelectorAll('[data-cart-count],.cart-count-bubble span,.cart-count'),function(c){c.textContent=cart.item_count;});
   });
  })
  .catch(function(err){if(toast){toast.querySelector('.zh-toast-msg').textContent=err.message;}else{f.submit();}})
  .then(function(){
   if(toast){toast.classList.add('zh-show');clearTimeout(toast._t);toast._t=setTimeout(function(){toast.classList.remove('zh-show');},6000);}
   setTimeout(function(){b.disabled=false;b.textContent=txt;},1800);
  });
 });
});
[].forEach.call(document.querySelectorAll('.zh-fan:not([data-ok])'),function(fan){
 fan.setAttribute('data-ok','1');
 var cards=[].slice.call(fan.querySelectorAll('.zh-card[data-i]'));if(cards.length<3)return;
 var busy=false,timer;
 function pos(c){return c.classList.contains('zh-pos-l')?'l':c.classList.contains('zh-pos-r')?'r':'c';}
 function front(c){
  if(busy||pos(c)==='c')return;busy=true;
  var cur=cards.filter(function(x){return pos(x)==='c';})[0],p=pos(c);
  c.classList.remove('zh-pos-'+p);c.classList.add('zh-pos-c');
  cur.classList.remove('zh-pos-c');cur.classList.add('zh-pos-'+p);
  setTimeout(function(){busy=false;},700);
 }
 cards.forEach(function(c){
  c.addEventListener('mouseenter',function(){clearTimeout(timer);timer=setTimeout(function(){front(c);},120);});
  c.addEventListener('mouseleave',function(){clearTimeout(timer);});
  c.addEventListener('click',function(){front(c);});
 });
});
[].forEach.call(document.querySelectorAll('.zh-snd:not([data-ok])'),function(b){
 b.setAttribute('data-ok','1');
 b.addEventListener('click',function(){var v=b.parentNode.querySelector('video');if(!v)return;
  v.muted=!v.muted;if(!v.muted){v.currentTime=0;v.play();}
  b.classList.toggle('zh-sonando',!v.muted);b.setAttribute('aria-label',v.muted?'Activar sonido':'Silenciar');});
});
};
zynaInit();
document.addEventListener("shopify:section:load",function(){setTimeout(zynaInit,50);});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zyna-08-promo"] && !Shopify.designMode) return;
  try {
    
(function(){
if(window.zynaLoaded)return;window.zynaLoaded=true;
window.zynaInit=function(){
var roots=document.querySelectorAll('.zh:not(.zh-js)');
[].forEach.call(roots,function(r){
 if(!('IntersectionObserver' in window))return;
 r.classList.add('zh-js');
 var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('zh-on');io.unobserve(e.target);}});},{threshold:.15});
 [].forEach.call(r.querySelectorAll('.zh-rv'),function(el){io.observe(el);});
});
[].forEach.call(document.querySelectorAll('.zh-tabs:not([data-ok])'),function(t){
 t.setAttribute('data-ok','1');var root=t.parentNode;
 [].forEach.call(t.querySelectorAll('.zh-tab'),function(b){
  b.addEventListener('click',function(){
   [].forEach.call(t.querySelectorAll('.zh-tab'),function(x){x.setAttribute('aria-selected',x===b?'true':'false');});
   [].forEach.call(root.querySelectorAll('.zh-panel'),function(p){p.hidden=(p.id!==b.getAttribute('aria-controls'));});
  });
 });
});
[].forEach.call(document.querySelectorAll('.zh-addform:not([data-ok])'),function(f){
 f.setAttribute('data-ok','1');
 f.addEventListener('submit',function(e){
  if(!window.fetch)return;
  e.preventDefault();
  var b=f.querySelector('button'),txt=b.textContent,root=f.closest('.zh'),toast=root&&root.querySelector('.zh-toast');
  b.disabled=true;b.textContent='Agregando…';
  var base=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
  fetch(base+'cart/add.js',{method:'POST',headers:{'Accept':'application/json'},body:new FormData(f)})
  .then(function(r){return r.json().then(function(j){return {ok:r.ok,j:j};});})
  .then(function(res){
   if(!res.ok)throw new Error(res.j.description||res.j.message||'No se pudo agregar');
   b.textContent='✓ Agregado';
   if(toast){toast.querySelector('.zh-toast-msg').textContent=res.j.product_title+' se agregó a tu carrito';}
   return fetch(base+'cart.js').then(function(r){return r.json();}).then(function(cart){
    document.dispatchEvent(new CustomEvent('cart:update',{bubbles:true,detail:{resource:cart,sourceId:'zyna',data:{itemCount:cart.item_count,source:'zyna'}}}));
    [].forEach.call(document.querySelectorAll('[data-cart-count],.cart-count-bubble span,.cart-count'),function(c){c.textContent=cart.item_count;});
   });
  })
  .catch(function(err){if(toast){toast.querySelector('.zh-toast-msg').textContent=err.message;}else{f.submit();}})
  .then(function(){
   if(toast){toast.classList.add('zh-show');clearTimeout(toast._t);toast._t=setTimeout(function(){toast.classList.remove('zh-show');},6000);}
   setTimeout(function(){b.disabled=false;b.textContent=txt;},1800);
  });
 });
});
[].forEach.call(document.querySelectorAll('.zh-fan:not([data-ok])'),function(fan){
 fan.setAttribute('data-ok','1');
 var cards=[].slice.call(fan.querySelectorAll('.zh-card[data-i]'));if(cards.length<3)return;
 var busy=false,timer;
 function pos(c){return c.classList.contains('zh-pos-l')?'l':c.classList.contains('zh-pos-r')?'r':'c';}
 function front(c){
  if(busy||pos(c)==='c')return;busy=true;
  var cur=cards.filter(function(x){return pos(x)==='c';})[0],p=pos(c);
  c.classList.remove('zh-pos-'+p);c.classList.add('zh-pos-c');
  cur.classList.remove('zh-pos-c');cur.classList.add('zh-pos-'+p);
  setTimeout(function(){busy=false;},700);
 }
 cards.forEach(function(c){
  c.addEventListener('mouseenter',function(){clearTimeout(timer);timer=setTimeout(function(){front(c);},120);});
  c.addEventListener('mouseleave',function(){clearTimeout(timer);});
  c.addEventListener('click',function(){front(c);});
 });
});
[].forEach.call(document.querySelectorAll('.zh-snd:not([data-ok])'),function(b){
 b.setAttribute('data-ok','1');
 b.addEventListener('click',function(){var v=b.parentNode.querySelector('video');if(!v)return;
  v.muted=!v.muted;if(!v.muted){v.currentTime=0;v.play();}
  b.classList.toggle('zh-sonando',!v.muted);b.setAttribute('aria-label',v.muted?'Activar sonido':'Silenciar');});
});
};
zynaInit();
document.addEventListener("shopify:section:load",function(){setTimeout(zynaInit,50);});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zyna-09-historias"] && !Shopify.designMode) return;
  try {
    
(function(){
if(window.zynaLoaded)return;window.zynaLoaded=true;
window.zynaInit=function(){
var roots=document.querySelectorAll('.zh:not(.zh-js)');
[].forEach.call(roots,function(r){
 if(!('IntersectionObserver' in window))return;
 r.classList.add('zh-js');
 var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('zh-on');io.unobserve(e.target);}});},{threshold:.15});
 [].forEach.call(r.querySelectorAll('.zh-rv'),function(el){io.observe(el);});
});
[].forEach.call(document.querySelectorAll('.zh-tabs:not([data-ok])'),function(t){
 t.setAttribute('data-ok','1');var root=t.parentNode;
 [].forEach.call(t.querySelectorAll('.zh-tab'),function(b){
  b.addEventListener('click',function(){
   [].forEach.call(t.querySelectorAll('.zh-tab'),function(x){x.setAttribute('aria-selected',x===b?'true':'false');});
   [].forEach.call(root.querySelectorAll('.zh-panel'),function(p){p.hidden=(p.id!==b.getAttribute('aria-controls'));});
  });
 });
});
[].forEach.call(document.querySelectorAll('.zh-addform:not([data-ok])'),function(f){
 f.setAttribute('data-ok','1');
 f.addEventListener('submit',function(e){
  if(!window.fetch)return;
  e.preventDefault();
  var b=f.querySelector('button'),txt=b.textContent,root=f.closest('.zh'),toast=root&&root.querySelector('.zh-toast');
  b.disabled=true;b.textContent='Agregando…';
  var base=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
  fetch(base+'cart/add.js',{method:'POST',headers:{'Accept':'application/json'},body:new FormData(f)})
  .then(function(r){return r.json().then(function(j){return {ok:r.ok,j:j};});})
  .then(function(res){
   if(!res.ok)throw new Error(res.j.description||res.j.message||'No se pudo agregar');
   b.textContent='✓ Agregado';
   if(toast){toast.querySelector('.zh-toast-msg').textContent=res.j.product_title+' se agregó a tu carrito';}
   return fetch(base+'cart.js').then(function(r){return r.json();}).then(function(cart){
    document.dispatchEvent(new CustomEvent('cart:update',{bubbles:true,detail:{resource:cart,sourceId:'zyna',data:{itemCount:cart.item_count,source:'zyna'}}}));
    [].forEach.call(document.querySelectorAll('[data-cart-count],.cart-count-bubble span,.cart-count'),function(c){c.textContent=cart.item_count;});
   });
  })
  .catch(function(err){if(toast){toast.querySelector('.zh-toast-msg').textContent=err.message;}else{f.submit();}})
  .then(function(){
   if(toast){toast.classList.add('zh-show');clearTimeout(toast._t);toast._t=setTimeout(function(){toast.classList.remove('zh-show');},6000);}
   setTimeout(function(){b.disabled=false;b.textContent=txt;},1800);
  });
 });
});
[].forEach.call(document.querySelectorAll('.zh-fan:not([data-ok])'),function(fan){
 fan.setAttribute('data-ok','1');
 var cards=[].slice.call(fan.querySelectorAll('.zh-card[data-i]'));if(cards.length<3)return;
 var busy=false,timer;
 function pos(c){return c.classList.contains('zh-pos-l')?'l':c.classList.contains('zh-pos-r')?'r':'c';}
 function front(c){
  if(busy||pos(c)==='c')return;busy=true;
  var cur=cards.filter(function(x){return pos(x)==='c';})[0],p=pos(c);
  c.classList.remove('zh-pos-'+p);c.classList.add('zh-pos-c');
  cur.classList.remove('zh-pos-c');cur.classList.add('zh-pos-'+p);
  setTimeout(function(){busy=false;},700);
 }
 cards.forEach(function(c){
  c.addEventListener('mouseenter',function(){clearTimeout(timer);timer=setTimeout(function(){front(c);},120);});
  c.addEventListener('mouseleave',function(){clearTimeout(timer);});
  c.addEventListener('click',function(){front(c);});
 });
});
[].forEach.call(document.querySelectorAll('.zh-snd:not([data-ok])'),function(b){
 b.setAttribute('data-ok','1');
 b.addEventListener('click',function(){var v=b.parentNode.querySelector('video');if(!v)return;
  v.muted=!v.muted;if(!v.muted){v.currentTime=0;v.play();}
  b.classList.toggle('zh-sonando',!v.muted);b.setAttribute('aria-label',v.muted?'Activar sonido':'Silenciar');});
});
};
zynaInit();
document.addEventListener("shopify:section:load",function(){setTimeout(zynaInit,50);});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zyna-10-supscripcion"] && !Shopify.designMode) return;
  try {
    
(function(){
if(window.zynaLoaded)return;window.zynaLoaded=true;
window.zynaInit=function(){
var roots=document.querySelectorAll('.zh:not(.zh-js)');
[].forEach.call(roots,function(r){
 if(!('IntersectionObserver' in window))return;
 r.classList.add('zh-js');
 var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('zh-on');io.unobserve(e.target);}});},{threshold:.15});
 [].forEach.call(r.querySelectorAll('.zh-rv'),function(el){io.observe(el);});
});
[].forEach.call(document.querySelectorAll('.zh-tabs:not([data-ok])'),function(t){
 t.setAttribute('data-ok','1');var root=t.parentNode;
 [].forEach.call(t.querySelectorAll('.zh-tab'),function(b){
  b.addEventListener('click',function(){
   [].forEach.call(t.querySelectorAll('.zh-tab'),function(x){x.setAttribute('aria-selected',x===b?'true':'false');});
   [].forEach.call(root.querySelectorAll('.zh-panel'),function(p){p.hidden=(p.id!==b.getAttribute('aria-controls'));});
  });
 });
});
[].forEach.call(document.querySelectorAll('.zh-addform:not([data-ok])'),function(f){
 f.setAttribute('data-ok','1');
 f.addEventListener('submit',function(e){
  if(!window.fetch)return;
  e.preventDefault();
  var b=f.querySelector('button'),txt=b.textContent,root=f.closest('.zh'),toast=root&&root.querySelector('.zh-toast');
  b.disabled=true;b.textContent='Agregando…';
  var base=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
  fetch(base+'cart/add.js',{method:'POST',headers:{'Accept':'application/json'},body:new FormData(f)})
  .then(function(r){return r.json().then(function(j){return {ok:r.ok,j:j};});})
  .then(function(res){
   if(!res.ok)throw new Error(res.j.description||res.j.message||'No se pudo agregar');
   b.textContent='✓ Agregado';
   if(toast){toast.querySelector('.zh-toast-msg').textContent=res.j.product_title+' se agregó a tu carrito';}
   return fetch(base+'cart.js').then(function(r){return r.json();}).then(function(cart){
    document.dispatchEvent(new CustomEvent('cart:update',{bubbles:true,detail:{resource:cart,sourceId:'zyna',data:{itemCount:cart.item_count,source:'zyna'}}}));
    [].forEach.call(document.querySelectorAll('[data-cart-count],.cart-count-bubble span,.cart-count'),function(c){c.textContent=cart.item_count;});
   });
  })
  .catch(function(err){if(toast){toast.querySelector('.zh-toast-msg').textContent=err.message;}else{f.submit();}})
  .then(function(){
   if(toast){toast.classList.add('zh-show');clearTimeout(toast._t);toast._t=setTimeout(function(){toast.classList.remove('zh-show');},6000);}
   setTimeout(function(){b.disabled=false;b.textContent=txt;},1800);
  });
 });
});
[].forEach.call(document.querySelectorAll('.zh-fan:not([data-ok])'),function(fan){
 fan.setAttribute('data-ok','1');
 var cards=[].slice.call(fan.querySelectorAll('.zh-card[data-i]'));if(cards.length<3)return;
 var busy=false,timer;
 function pos(c){return c.classList.contains('zh-pos-l')?'l':c.classList.contains('zh-pos-r')?'r':'c';}
 function front(c){
  if(busy||pos(c)==='c')return;busy=true;
  var cur=cards.filter(function(x){return pos(x)==='c';})[0],p=pos(c);
  c.classList.remove('zh-pos-'+p);c.classList.add('zh-pos-c');
  cur.classList.remove('zh-pos-c');cur.classList.add('zh-pos-'+p);
  setTimeout(function(){busy=false;},700);
 }
 cards.forEach(function(c){
  c.addEventListener('mouseenter',function(){clearTimeout(timer);timer=setTimeout(function(){front(c);},120);});
  c.addEventListener('mouseleave',function(){clearTimeout(timer);});
  c.addEventListener('click',function(){front(c);});
 });
});
[].forEach.call(document.querySelectorAll('.zh-snd:not([data-ok])'),function(b){
 b.setAttribute('data-ok','1');
 b.addEventListener('click',function(){var v=b.parentNode.querySelector('video');if(!v)return;
  v.muted=!v.muted;if(!v.muted){v.currentTime=0;v.play();}
  b.classList.toggle('zh-sonando',!v.muted);b.setAttribute('aria-label',v.muted?'Activar sonido':'Silenciar');});
});
};
zynaInit();
document.addEventListener("shopify:section:load",function(){setTimeout(zynaInit,50);});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zyna-11-faq"] && !Shopify.designMode) return;
  try {
    
(function(){
if(window.zynaLoaded)return;window.zynaLoaded=true;
window.zynaInit=function(){
var roots=document.querySelectorAll('.zh:not(.zh-js)');
[].forEach.call(roots,function(r){
 if(!('IntersectionObserver' in window))return;
 r.classList.add('zh-js');
 var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('zh-on');io.unobserve(e.target);}});},{threshold:.15});
 [].forEach.call(r.querySelectorAll('.zh-rv'),function(el){io.observe(el);});
});
[].forEach.call(document.querySelectorAll('.zh-tabs:not([data-ok])'),function(t){
 t.setAttribute('data-ok','1');var root=t.parentNode;
 [].forEach.call(t.querySelectorAll('.zh-tab'),function(b){
  b.addEventListener('click',function(){
   [].forEach.call(t.querySelectorAll('.zh-tab'),function(x){x.setAttribute('aria-selected',x===b?'true':'false');});
   [].forEach.call(root.querySelectorAll('.zh-panel'),function(p){p.hidden=(p.id!==b.getAttribute('aria-controls'));});
  });
 });
});
[].forEach.call(document.querySelectorAll('.zh-addform:not([data-ok])'),function(f){
 f.setAttribute('data-ok','1');
 f.addEventListener('submit',function(e){
  if(!window.fetch)return;
  e.preventDefault();
  var b=f.querySelector('button'),txt=b.textContent,root=f.closest('.zh'),toast=root&&root.querySelector('.zh-toast');
  b.disabled=true;b.textContent='Agregando…';
  var base=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
  fetch(base+'cart/add.js',{method:'POST',headers:{'Accept':'application/json'},body:new FormData(f)})
  .then(function(r){return r.json().then(function(j){return {ok:r.ok,j:j};});})
  .then(function(res){
   if(!res.ok)throw new Error(res.j.description||res.j.message||'No se pudo agregar');
   b.textContent='✓ Agregado';
   if(toast){toast.querySelector('.zh-toast-msg').textContent=res.j.product_title+' se agregó a tu carrito';}
   return fetch(base+'cart.js').then(function(r){return r.json();}).then(function(cart){
    document.dispatchEvent(new CustomEvent('cart:update',{bubbles:true,detail:{resource:cart,sourceId:'zyna',data:{itemCount:cart.item_count,source:'zyna'}}}));
    [].forEach.call(document.querySelectorAll('[data-cart-count],.cart-count-bubble span,.cart-count'),function(c){c.textContent=cart.item_count;});
   });
  })
  .catch(function(err){if(toast){toast.querySelector('.zh-toast-msg').textContent=err.message;}else{f.submit();}})
  .then(function(){
   if(toast){toast.classList.add('zh-show');clearTimeout(toast._t);toast._t=setTimeout(function(){toast.classList.remove('zh-show');},6000);}
   setTimeout(function(){b.disabled=false;b.textContent=txt;},1800);
  });
 });
});
[].forEach.call(document.querySelectorAll('.zh-fan:not([data-ok])'),function(fan){
 fan.setAttribute('data-ok','1');
 var cards=[].slice.call(fan.querySelectorAll('.zh-card[data-i]'));if(cards.length<3)return;
 var busy=false,timer;
 function pos(c){return c.classList.contains('zh-pos-l')?'l':c.classList.contains('zh-pos-r')?'r':'c';}
 function front(c){
  if(busy||pos(c)==='c')return;busy=true;
  var cur=cards.filter(function(x){return pos(x)==='c';})[0],p=pos(c);
  c.classList.remove('zh-pos-'+p);c.classList.add('zh-pos-c');
  cur.classList.remove('zh-pos-c');cur.classList.add('zh-pos-'+p);
  setTimeout(function(){busy=false;},700);
 }
 cards.forEach(function(c){
  c.addEventListener('mouseenter',function(){clearTimeout(timer);timer=setTimeout(function(){front(c);},120);});
  c.addEventListener('mouseleave',function(){clearTimeout(timer);});
  c.addEventListener('click',function(){front(c);});
 });
});
[].forEach.call(document.querySelectorAll('.zh-snd:not([data-ok])'),function(b){
 b.setAttribute('data-ok','1');
 b.addEventListener('click',function(){var v=b.parentNode.querySelector('video');if(!v)return;
  v.muted=!v.muted;if(!v.muted){v.currentTime=0;v.play();}
  b.classList.toggle('zh-sonando',!v.muted);b.setAttribute('aria-label',v.muted?'Activar sonido':'Silenciar');});
});
};
zynaInit();
document.addEventListener("shopify:section:load",function(){setTimeout(zynaInit,50);});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zyna-12-pie"] && !Shopify.designMode) return;
  try {
    
(function(){
if(window.zynaLoaded)return;window.zynaLoaded=true;
window.zynaInit=function(){
var roots=document.querySelectorAll('.zh:not(.zh-js)');
[].forEach.call(roots,function(r){
 if(!('IntersectionObserver' in window))return;
 r.classList.add('zh-js');
 var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('zh-on');io.unobserve(e.target);}});},{threshold:.15});
 [].forEach.call(r.querySelectorAll('.zh-rv'),function(el){io.observe(el);});
});
[].forEach.call(document.querySelectorAll('.zh-tabs:not([data-ok])'),function(t){
 t.setAttribute('data-ok','1');var root=t.parentNode;
 [].forEach.call(t.querySelectorAll('.zh-tab'),function(b){
  b.addEventListener('click',function(){
   [].forEach.call(t.querySelectorAll('.zh-tab'),function(x){x.setAttribute('aria-selected',x===b?'true':'false');});
   [].forEach.call(root.querySelectorAll('.zh-panel'),function(p){p.hidden=(p.id!==b.getAttribute('aria-controls'));});
  });
 });
});
[].forEach.call(document.querySelectorAll('.zh-addform:not([data-ok])'),function(f){
 f.setAttribute('data-ok','1');
 f.addEventListener('submit',function(e){
  if(!window.fetch)return;
  e.preventDefault();
  var b=f.querySelector('button'),txt=b.textContent,root=f.closest('.zh'),toast=root&&root.querySelector('.zh-toast');
  b.disabled=true;b.textContent='Agregando…';
  var base=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
  fetch(base+'cart/add.js',{method:'POST',headers:{'Accept':'application/json'},body:new FormData(f)})
  .then(function(r){return r.json().then(function(j){return {ok:r.ok,j:j};});})
  .then(function(res){
   if(!res.ok)throw new Error(res.j.description||res.j.message||'No se pudo agregar');
   b.textContent='✓ Agregado';
   if(toast){toast.querySelector('.zh-toast-msg').textContent=res.j.product_title+' se agregó a tu carrito';}
   return fetch(base+'cart.js').then(function(r){return r.json();}).then(function(cart){
    document.dispatchEvent(new CustomEvent('cart:update',{bubbles:true,detail:{resource:cart,sourceId:'zyna',data:{itemCount:cart.item_count,source:'zyna'}}}));
    [].forEach.call(document.querySelectorAll('[data-cart-count],.cart-count-bubble span,.cart-count'),function(c){c.textContent=cart.item_count;});
   });
  })
  .catch(function(err){if(toast){toast.querySelector('.zh-toast-msg').textContent=err.message;}else{f.submit();}})
  .then(function(){
   if(toast){toast.classList.add('zh-show');clearTimeout(toast._t);toast._t=setTimeout(function(){toast.classList.remove('zh-show');},6000);}
   setTimeout(function(){b.disabled=false;b.textContent=txt;},1800);
  });
 });
});
[].forEach.call(document.querySelectorAll('.zh-fan:not([data-ok])'),function(fan){
 fan.setAttribute('data-ok','1');
 var cards=[].slice.call(fan.querySelectorAll('.zh-card[data-i]'));if(cards.length<3)return;
 var busy=false,timer;
 function pos(c){return c.classList.contains('zh-pos-l')?'l':c.classList.contains('zh-pos-r')?'r':'c';}
 function front(c){
  if(busy||pos(c)==='c')return;busy=true;
  var cur=cards.filter(function(x){return pos(x)==='c';})[0],p=pos(c);
  c.classList.remove('zh-pos-'+p);c.classList.add('zh-pos-c');
  cur.classList.remove('zh-pos-c');cur.classList.add('zh-pos-'+p);
  setTimeout(function(){busy=false;},700);
 }
 cards.forEach(function(c){
  c.addEventListener('mouseenter',function(){clearTimeout(timer);timer=setTimeout(function(){front(c);},120);});
  c.addEventListener('mouseleave',function(){clearTimeout(timer);});
  c.addEventListener('click',function(){front(c);});
 });
});
[].forEach.call(document.querySelectorAll('.zh-snd:not([data-ok])'),function(b){
 b.setAttribute('data-ok','1');
 b.addEventListener('click',function(){var v=b.parentNode.querySelector('video');if(!v)return;
  v.muted=!v.muted;if(!v.muted){v.currentTime=0;v.play();}
  b.classList.toggle('zh-sonando',!v.muted);b.setAttribute('aria-label',v.muted?'Activar sonido':'Silenciar');});
});
};
zynaInit();
document.addEventListener("shopify:section:load",function(){setTimeout(zynaInit,50);});
})();

  } catch(e) { console.error(e); }
})();
})();
